import { useTranslation } from 'react-i18next';
import { PostModal, PostModalProps } from '../shared';
import { Template, TemplateProps, TemplatePostDetailsType } from './template';

export type InfluencerPostDetailsModalProps = Pick<TemplateProps, 'hasSimilarPosts'> &
  Omit<PostModalProps<TemplatePostDetailsType>, 'children'>;

export const InfluencerPostDetailsModal = ({ hasSimilarPosts, ...postModalProps }: InfluencerPostDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal {...postModalProps}>
      <PostModal.Title>{t('Post Detail')}</PostModal.Title>
      <Template hasSimilarPosts={hasSimilarPosts} />
    </PostModal>
  );
};
